import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {
  ReactPlugin,
  withAITracking,
} from '@microsoft/applicationinsights-react-js';

let appInsights;
let reactPlugin;

export const initializeMetrics = history => {
  if (process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY) {
    reactPlugin = new ReactPlugin();
    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey:
          process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {history},
        },
      },
    });
    appInsights.loadAppInsights();
  }
};

export const withMetrics = (Component, componentName, className) =>
  appInsights
    ? withAITracking(reactPlugin, componentName, className)
    : Component;

export const trackException = error => {
  if (appInsights) {
    appInsights.trackException({
      error: error instanceof Error ? error : new Error(error),
    });
  }
};
